export interface SnackbarState {
    message: string;
    open: boolean;
}

export const initialSnackbarState: SnackbarState = {
    message: '',
    open: false,
};
